"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEpoqRequestParams = void 0;
const epoq_config_1 = __importDefault(require("./epoq-config"));
const use_department_1 = __importDefault(require("@/SearchApp/composables/use-department"));
const { departmentCapitalized } = (0, use_department_1.default)();
const getEpoqRequestParams = (query = "") => {
    const { customerId, tenantId, sessionId } = (0, epoq_config_1.default)();
    return {
        customerId,
        format: "json",
        // ⚠️ attribute name has to be "e:gender" but value has to be department
        matchAttr: "e:gender",
        matchType: "filter",
        matchValue: departmentCapitalized.value,
        query,
        sessionId,
        style: "compact",
        tenantId,
    };
};
exports.getEpoqRequestParams = getEpoqRequestParams;
